import React from "react";
import SettingsPage from "../../components/Design/Settings/SettingsPage";
import SettingsPageContent from "../../components/Design/Settings/SettingsPageContent";
import { useApiStates } from "../../state/Store";
import ExecutionTable from "./ExecutionTable";

const ExecutionScreen: React.FC = () => {
    const api = useApiStates("executions", "scenarios", "workers", "executionErrors");

    return (
        <SettingsPage title="Ausführungen">

            <SettingsPageContent api={api}>

                <ExecutionTable
                    executionErrors={api.executionErrors.value ?? []}
                    executions={api.executions.value ?? []}
                    scenarios={api.scenarios.value ?? []}
                    workers={api.workers.value ?? []} />

            </SettingsPageContent>

        </SettingsPage>
    );
};

export default ExecutionScreen;
